module.exports = __webpack_public_path__ + "img/logo.bcdfa107.svg";